import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Category } from '../../entities/category_layers/category';
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class CategoryService {
  // Define API
 
  //apiURL = environment.apiUrl;
apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Optionsrealgis_cc
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  

  // HttpClient API get() method => Fetch layer list
  getCategories(): Observable<Category> {
    return this.http.get<Category>(this.apiURL + '/getcategoriacapa')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API get() method => Fetch layer
  getCategory(id): Observable<Category> {
    return this.http.get<Category>(this.apiURL + '/categoria_capa/' + id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API post() method => Create layer
  createCategory(category): Observable<Category> {
    return this.http.post<Category>(this.apiURL + '/categoria_capa/0', JSON.stringify(category), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API put() method => Update layer
  updateCategory(id, category): Observable<Category> {
    return this.http.put<Category>(this.apiURL + '/categoria_capa/' + id, JSON.stringify(category), this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }
  // HttpClient API delete() method => Delete layer
  deleteCategory(id) {
    return this.http.delete<Category>(this.apiURL + '/categoria_capa/' + id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error) {
    let errorMessage = 'Hola categoria';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Codigo Error(Category): ${error.status}\nMensaje Error: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
